var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [
        { navigation: this.$route.path === `/${_vm.PAGES.login}` },
        "notification-wrapper",
        { "white-notification": this.$route.meta.isGopRedesign }
      ]
    },
    [
      _c(
        "transition-group",
        {
          staticStyle: { position: "relative", "z-index": "999" },
          attrs: {
            appear: "",
            "enter-active-class": "animate__animated animate__fadeInLeft",
            "leave-active-class": "animate__animated animate__fadeOutLeft",
            mode: "out-in"
          }
        },
        _vm._l(_vm.getNotifications, function(notification) {
          return _c("SingleNotification", {
            key: Number(notification.indexOfNotification),
            attrs: {
              message: notification.message,
              type: notification.type,
              indexOfNotification: notification.indexOfNotification
            }
          })
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }